(() => {
  const booking = document.querySelector('[data-pk-booking]');
  if (!booking) return;

  const days = booking.querySelector('[data-pk-booking-days]');
  const slots = booking.querySelector('[data-pk-booking-slots]');
  const form = booking.querySelector('[data-pk-booking-form]');
  const success = booking.querySelector('[data-pk-booking-success]');
  const summaryType = booking.querySelector('[data-pk-summary-type]');
  const summaryDate = booking.querySelector('[data-pk-summary-date]');
  const phone = booking.querySelector('[data-pk-phone]');
  const errorMessage = booking.querySelector('[data-pk-booking-error]');
  const endpoint = 'https://livorno-polsterkonfigurator.dietschrobert54.chatgpt.site/api/appointments';
  let selectedDate = null;
  let selectedTime = '';

  const formatDay = (date) => new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }).format(date);
  const formatFull = (date) => new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(date);
  const availableDays = [];
  const cursor = new Date();
  // Two calendar days guarantee the promised minimum lead time of 24 hours.
  cursor.setDate(cursor.getDate() + 2);
  while (availableDays.length < 7) {
    if (cursor.getDay() !== 0 && cursor.getDay() !== 6) availableDays.push(new Date(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }

  const dateKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  const renderSlots = async () => {
    slots.innerHTML = '';
    slots.setAttribute('aria-busy', 'true');
    let occupied = [];
    try {
      const response = await fetch(`${endpoint}?date=${dateKey(selectedDate)}`, { cache: 'no-store' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Belegte Zeiten konnten nicht geladen werden.');
      occupied = Array.isArray(data.occupied) ? data.occupied : [];
    } catch (error) {
      errorMessage.textContent = error instanceof Error ? error.message : 'Die Terminverfügbarkeit konnte nicht geladen werden.';
      errorMessage.hidden = false;
    }
    for (let hour = 9; hour < 18; hour += 1) {
      for (const minute of [0, 30]) {
        if (hour === 12) continue;
        const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pk-booking-slot';
        const unavailable = occupied.includes(time);
        button.textContent = unavailable ? `${time} belegt` : `${time} Uhr`;
        button.disabled = unavailable;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          slots.querySelectorAll('button').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          selectedTime = time;
          summaryDate.textContent = `${formatFull(selectedDate)}, ${time} Uhr`;
          form.hidden = false;
          form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        slots.appendChild(button);
      }
    }
    slots.removeAttribute('aria-busy');
  };

  availableDays.forEach((date, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pk-booking-day';
    button.textContent = formatDay(date);
    button.setAttribute('aria-pressed', 'false');
    button.addEventListener('click', (event) => {
      days.querySelectorAll('button').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      selectedDate = date;
      selectedTime = '';
      summaryDate.textContent = formatFull(date);
      form.hidden = true;
      errorMessage.hidden = true;
      // Keep the natural top-of-page entry intact when the first day is
      // selected programmatically during initialisation. Only a deliberate
      // customer click should move the visible calendar row into view.
      if (event.isTrusted) {
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      renderSlots();
    });
    days.appendChild(button);
    if (index === 0) button.click();
  });

  booking.querySelectorAll('input[name="pk-booking-type"]').forEach((input) => input.addEventListener('change', () => {
    summaryType.textContent = input.value;
    const isPhone = input.value === 'Telefonberatung';
    phone.hidden = !isPhone;
    phone.querySelector('input').required = isPhone;
  }));

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity() || !selectedDate || !selectedTime) return;
    const type = booking.querySelector('input[name="pk-booking-type"]:checked').value;
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.disabled = true;
    submitButton.textContent = 'Termin wird gebucht …';
    errorMessage.hidden = true;
    const payload = {
      type,
      startsAt: `${dateKey(selectedDate)}T${selectedTime}:00`,
      name: String(formData.get('name') || ''),
      email: String(formData.get('email') || ''),
      phone: String(formData.get('phone') || ''),
      model: String(formData.get('model') || ''),
      message: String(formData.get('message') || ''),
      privacyConsent: formData.get('privacyConsent') === 'on',
      consentTextVersion: String(formData.get('consentTextVersion') || '')
    };
    try {
      const response = await fetch(endpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Termin konnte nicht gebucht werden.');
      booking.querySelector('[data-pk-booking-confirmation]').textContent = `${type} am ${formatFull(selectedDate)} um ${selectedTime} Uhr – 20 Minuten.`;
      booking.querySelector('[data-pk-booking-number]').textContent = `Deine Terminnummer: ${data.appointmentNumber}`;
      form.hidden = true;
      success.hidden = false;
      success.focus();
    } catch (error) {
      errorMessage.textContent = error instanceof Error ? error.message : 'Termin konnte nicht gebucht werden.';
      errorMessage.hidden = false;
      if (String(errorMessage.textContent).includes('vergeben')) renderSlots();
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Termin verbindlich buchen';
    }
  });

  booking.querySelector('[data-pk-booking-reset]').addEventListener('click', () => {
    success.hidden = true;
    form.reset();
    selectedTime = '';
    summaryDate.textContent = formatFull(selectedDate);
    form.hidden = true;
    renderSlots();
    booking.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
